import * as React from 'react';
import { UIText1, UIText2 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IDepartmentLinkProps {
  href: string;
  size: 'large' | 'small';
  /** Ссылка есть и в панели, и в модалке оценки — testid задаёт вызывающий, чтобы они не совпадали. */
  testId: string;
  onClick?(): void;
}

/** Ссылка на методику Дептранса — текст и вёрстка как в map-search. */
export function DepartmentLink({ href, size, testId, onClick }: IDepartmentLinkProps): React.JSX.Element {
  const UIText = size === 'large' ? UIText1 : UIText2;

  return (
    <UIText>
      Подробнее о рейтинге на{' '}
      <a className={styles['link']} data-testid={testId} href={href} rel="noreferrer" target="_blank" onClick={onClick}>
        сайте
      </a>{' '}
      от&nbsp;Департамента транспорта Москвы
    </UIText>
  );
}
